import { Injectable, Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

import { TimeAgoBase } from './timeago';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'rtTimeAgo',
  pure: true,
  standalone: true,
})
export class TimeAgoPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value?: moment.MomentInput,
    { omitSuffix }: { omitSuffix: boolean } = { omitSuffix: false },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, omitSuffix);
  }
}
